import gql from "graphql-tag";

export const GET_DEAL_BY_ID = gql`
  query deals_by_pk($id: uuid!) {
    deals_by_pk(id: $id) {
      id
      name
      description
      condition
      created_at
      updated_at
      expire_date_time
      type
      image_url
      image_path
    }
  }
`;
